import Reflux from "reflux";

export const ActionsGlobalMediaLibrary = Reflux.createActions({
  getCloudinaryImagesByCompanyId: { asyncResult: true },
  getOldUploadedImages: { asyncResult: true },
  getOldUploadedLogos: { asyncResult: true },
  setCompanyId: {},
  setCompanyName: {},
  newlyUploadedImages: {},
  newlyUploadedLogos: {},
  startUpload: {},
  uploadComplete: {},
  // Filter actions
  setFilter: {},
  clearFilters: {},
  toggleFilter: {},
  setShowKPIs: {},
  setShowOnlyFavorites: {},
  setShowShutterstock: {},
  // Like actions
  likeCloudinaryAsset: { asyncResult: true }
});
